import { render, staticRenderFns } from "./ProductArea.vue?vue&type=template&id=60ede610&scoped=true"
import script from "./ProductArea.vue?vue&type=script&lang=js"
export * from "./ProductArea.vue?vue&type=script&lang=js"
import style0 from "./ProductArea.vue?vue&type=style&index=0&id=60ede610&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ede610",
  null
  
)

export default component.exports